import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
const Login = () => {
  const { loginWithRedirect, isLoading } = useAuth0()
  useEffect(() => {
    if (!isLoading) {
      loginWithRedirect({ screen_hint: 'signup' })
    }
  }, [isLoading, loginWithRedirect])
  return (
    <div>
      <p>Redirecting to sign up...</p>
    </div>
  )
}
export default Login
